import { SIDEBAR_ATOM_ROW_HEIGHT } from '../../../../modules/app-sidebar/views/sidebar-layout';
import {
  SIDEBAR_NAVIGATION_ROW_GAP,
  SIDEBAR_NAVIGATION_ROW_ICON_SIZE,
  SIDEBAR_NAVIGATION_ROW_PADDING_X,
  SIDEBAR_NAVIGATION_ROW_RADIUS,
  SIDEBAR_NAVIGATION_TREE_INDENT,
} from '../../../../modules/app-sidebar/views/sidebar-navigation-row';

export const NAVIGATION_PANEL_TREE_ROW_HEIGHT = SIDEBAR_ATOM_ROW_HEIGHT;
export const NAVIGATION_PANEL_TREE_ROW_PADDING_X =
  SIDEBAR_NAVIGATION_ROW_PADDING_X;
export const NAVIGATION_PANEL_TREE_ROW_RADIUS = SIDEBAR_NAVIGATION_ROW_RADIUS;
export const NAVIGATION_PANEL_TREE_ICON_SLOT_SIZE =
  SIDEBAR_NAVIGATION_ROW_ICON_SIZE;
export const NAVIGATION_PANEL_TREE_ITEM_GAP = SIDEBAR_NAVIGATION_ROW_GAP;
export const NAVIGATION_PANEL_TREE_LEVEL_INDENT =
  SIDEBAR_NAVIGATION_TREE_INDENT;
